import { env } from '@/shared/lib/env';
import type { UserForm } from './admin-user.store';

export type CreateFormIssue =
  | 'emailRequired'
  | 'organizationRequired'
  | 'passwordTooShort'
  | 'passwordMismatch';

export const getCreateIssue = (form: UserForm): CreateFormIssue | null => {
  if (!form.email) return 'emailRequired';
  if (!form.organization) return 'organizationRequired';
  if (form.withPassword) {
    if (form.password.length < env.VITE_PASSWORD_MIN) return 'passwordTooShort';
    if (form.password !== form.confirmPassword) return 'passwordMismatch';
  }
  return null;
};
